var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex items-center w-full gap-4",
      class: { "py-2 border-b border-grey-200": _vm.readOnly },
      attrs: { id: "prompting-item" }
    },
    [
      _vm.data.is_default && !_vm.readOnly
        ? _c(
            "div",
            {
              staticClass:
                "flex items-center justify-end flex-shrink-0 px-4 text-sm border rounded outline-none w-15 h-11 bg-slate-200 border-grey-200 "
            },
            [
              _c("BlTextBody1", {
                staticClass: "text-sm text-right text-slate-600",
                attrs: { text: _vm.data.score }
              })
            ],
            1
          )
        : _vm.readOnly
        ? _c(
            "div",
            { staticClass: "flex items-center flex-shrink-0 w-15 h-11" },
            [_c("BlTextBody1", { attrs: { text: _vm.data.score } })],
            1
          )
        : _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.data.score,
                expression: "data.score"
              }
            ],
            staticClass:
              "flex-shrink-0 px-4 text-sm text-right border rounded outline-none w-15 h-11 border-grey-200 focus:border-light-purple text-grey",
            class: { "border-error-400": _vm.errors.score },
            attrs: { type: "number", disabled: _vm.readOnly },
            domProps: { value: _vm.data.score },
            on: {
              blur: function($event) {
                $event.preventDefault()
                return _vm.onUpdate($event)
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.data, "score", $event.target.value)
              }
            }
          }),
      _vm._v(" "),
      _vm.data.is_default && !_vm.readOnly
        ? _c(
            "div",
            {
              staticClass:
                "flex items-center flex-shrink-0 px-4 text-sm border rounded outline-none w-15 h-11 border-grey-200 bg-slate-200 "
            },
            [
              _c("BlTextBody1", {
                staticClass: "text-sm text-left text-slate-600",
                attrs: { text: _vm.data.abbreviation }
              })
            ],
            1
          )
        : _vm.readOnly
        ? _c(
            "div",
            { staticClass: "flex items-center flex-shrink-0 w-15 h-11" },
            [_c("BlTextBody1", { attrs: { text: _vm.data.abbreviation } })],
            1
          )
        : _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.data.abbreviation,
                expression: "data.abbreviation"
              }
            ],
            staticClass:
              "flex-shrink-0 px-4 text-sm border rounded outline-none w-15 h-11 border-grey-200 focus:border-light-purple text-grey",
            class: { "border-error-400": _vm.errors.abbreviation },
            attrs: { type: "text", disabled: _vm.readOnly },
            domProps: { value: _vm.data.abbreviation },
            on: {
              blur: function($event) {
                $event.preventDefault()
                return _vm.onUpdate($event)
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.data, "abbreviation", $event.target.value)
              }
            }
          }),
      _vm._v(" "),
      _vm.data.is_default && !_vm.readOnly
        ? _c(
            "div",
            {
              staticClass:
                "flex items-center w-full px-4 border rounded outline-none h-11 border-grey-200 bg-slate-200 "
            },
            [
              _c("BlTextBody1", {
                staticClass: "text-sm text-left text-slate-600",
                attrs: { text: _vm.data.name }
              })
            ],
            1
          )
        : _vm.readOnly
        ? _c(
            "div",
            { staticClass: "flex items-center w-full h-11" },
            [_c("BlTextBody1", { attrs: { text: _vm.data.name } })],
            1
          )
        : _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.data.name,
                expression: "data.name"
              }
            ],
            staticClass:
              "w-full px-4 text-sm border rounded outline-none h-11 border-grey-200 focus:border-light-purple text-grey",
            class: { "border-error-400": _vm.errors.name },
            attrs: { type: "text", disabled: _vm.readOnly },
            domProps: { value: _vm.data.name },
            on: {
              blur: function($event) {
                $event.preventDefault()
                return _vm.onUpdate($event)
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.data, "name", $event.target.value)
              }
            }
          }),
      _vm._v(" "),
      !_vm.data.is_default && !_vm.readOnly
        ? _c(
            "div",
            {
              staticClass:
                "flex items-center flex-shrink-0 w-0.5 cursor-pointer",
              class: { "cursor-not-allowed ": _vm.disabledDelete },
              attrs: { disabled: _vm.disabledDelete },
              on: { click: _vm.openDelete }
            },
            [
              _c("BlIcon", {
                attrs: {
                  icon: "delete",
                  "tooltip-position": _vm.tooltipPosition,
                  color: _vm.disabledDelete ? "grey" : "error",
                  tooltip: _vm.tooltipDelete
                }
              })
            ],
            1
          )
        : _c("div", { staticClass: "flex-shrink-0  w-0.5" }),
      _vm._v(" "),
      _vm.deleteOpened
        ? _c("BlBackdrop", {
            attrs: {
              title: "Delete the prompt",
              label: "Delete",
              description:
                "Deleting this prompt from the repository will only affect new targets going forward. Are you sure you want to proceed? This action is irreversible.",
              type: "error",
              empty: ""
            },
            on: {
              "backdrop-close": function($event) {
                _vm.deleteOpened = false
              },
              "backdrop-action": _vm.onRemove
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34794712", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34794712","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/repository/sbt/PromptingItem.vue
// module id = null
// module chunks = 